module.exports = __webpack_public_path__ + "static/media/AMDM.a0c01fc0.JPG";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/AMDM.JPG
// module id = 1708
// module chunks = 1